// src/utils/swiper.js
// import { Swiper } from "swiper";
// import { register } from "swiper/element/bundle";
import Swiper from "swiper/bundle"; // 全ての機能が入っている
import { Navigation, Pagination, A11y } from "swiper/modules";

// スタイルのインポート
import "swiper/scss";
import "swiper/scss/a11y";
import "swiper/scss/navigation";
import "swiper/scss/pagination";

// register();

// Swiperモジュールの登録
Swiper.use([Navigation, Pagination, A11y]);

const globalSwiperSettings = {
 loop: true,
 centeredSlides: true,
 spaceBetween: 20,
 slidesPerView: 1,
 pagination: {
  el: ".swiper-pagination-custom",
  type: "fraction",
  renderFraction: (currentClass, totalClass) => {
   return '<span class="' + currentClass + '"></span>' + " | " + '<span class="' + totalClass + '"></span>';
  },
 },
 a11y: true,
 lazy: true,
 keyboard: {
  enabled: true,
  onlyInViewport: false,
 },
 on: {
  slideChangeTransitionStart: function () {
   const videos = this.el.querySelectorAll(".swiper-slide-active video");
   videos.forEach((video) => {
    video.currentTime = 0;
    video.play();
   });
  },
 },
};

export { Swiper, globalSwiperSettings };
